var $grid = $('.listing--sort').isotope({
    itemSelector: '.listing__item--sort ',
    layoutMode: 'fitRows',
});


var filterFns = {
    // show if number is greater than 50
    numberGreaterThan50: function () {
        var number = $(this).find('.number').text();
        return parseInt(number, 10) > 50;
    },
    // show if name ends with -ium
    ium: function () {
        var name = $(this).find('.name').text();
        return name.match(/ium$/);
    }
};

$('.nav__category').on('click', '.nav__link', function () {
    $('.nav__link').removeClass('active');
    $(this).addClass('active');

    var filterValue = $(this).attr('data-filter');
    // use filterFn if matches value
    filterValue = filterFns[filterValue] || filterValue;
    $grid.isotope({filter: filterValue});
});